import { FlexContainer } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { ButtonTabStyled } from './Styles';

export const Filter = () => {
  const { t } = useTranslation();

  return (
    <FlexContainer flexDirection="row" columnGap="3.2">
      <ButtonTabStyled
        className="groupButton"
        options={[
          {
            isActive: true,
            label: t('This week')!,
            onClick: function ka() {},
          },
          {
            isActive: false,
            label: t('This month')!,
            onClick: function ka() {},
          },
          {
            isActive: false,
            label: t('This year')!,
            onClick: function ka() {},
          },
        ]}
      />
    </FlexContainer>
  );
};
